
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { MessageSquarePlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type EmptyRequestListProps = {
  type: 'sent' | 'received';
  isCandidat?: boolean;
  onRequestFeedback?: () => void; // Ajout d'une prop pour le callback
};

const EmptyRequestList: React.FC<EmptyRequestListProps> = ({ 
  type, 
  isCandidat,
  onRequestFeedback
}) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (onRequestFeedback) {
      onRequestFeedback();
    } else {
      navigate('/request');
    }
  };

  return (
    <Card className="shadow-sm">
      <CardHeader>
        <CardTitle>
          {type === 'sent' 
            ? 'Aucune demande de feedback envoyée' 
            : 'Aucune demande de feedback reçue'}
        </CardTitle>
        <CardDescription>
          {type === 'sent' 
            ? 'Vous n\'avez pas encore envoyé de demande de feedback' 
            : 'Vous n\'avez pas encore reçu de demande de feedback'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {type === 'sent' && (
          <Button 
            onClick={handleClick}
            className="w-full sm:w-auto"
          >
            <MessageSquarePlus className="mr-2 h-4 w-4" />
            Demander un feedback
          </Button>
        )}
        {type === 'received' && (
          <p className="text-sm text-gray-500">
            Les demandes de feedback que vous recevrez apparaîtront ici.
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default EmptyRequestList;
